module.exports = __webpack_public_path__ + "2eda82ccaad536580c51cf1efbc3490b.jpg";